export default { 
  name : 'product.event.time',
  objectType : 'product.event',
  valueType : 'timestamp',
  displayName : 'Time',
  get : ( obj, cxt ) => {
    if ( !obj?.time ) {
      return null
    }
    
    return new Date( obj.time )
  }
}
